var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.400024C4.69705 0.400024 0.399048 4.69802 0.399048 10C0.398917 11.2609 0.647164 12.5094 1.12961 13.6743C1.61206 14.8392 2.31926 15.8977 3.21082 16.7892C4.10238 17.6808 5.16084 18.388 6.32575 18.8705C7.49065 19.3529 8.73919 19.6012 10 19.601C15.301 19.601 19.6 15.303 19.6 10C19.6 4.69802 15.301 0.400024 10 0.400024ZM10.896 3.86602C11.832 3.86602 12.107 4.40902 12.107 5.03002C12.107 5.80502 11.487 6.52202 10.428 6.52202C9.54205 6.52202 9.12005 6.07702 9.14605 5.34002C9.14605 4.71902 9.66505 3.86602 10.896 3.86602ZM8.49805 15.75C7.85805 15.75 7.39105 15.361 7.83805 13.656L8.57105 10.631C8.69805 10.147 8.71905 9.95302 8.57105 9.95302C8.38005 9.95302 7.54905 10.287 7.05905 10.617L6.74005 10.094C8.29505 8.79502 10.083 8.03302 10.848 8.03302C11.488 8.03302 11.594 8.78902 11.275 9.95302L10.435 13.133C10.286 13.695 10.35 13.889 10.499 13.889C10.691 13.889 11.319 13.657 11.937 13.17L12.299 13.656C10.786 15.168 9.13705 15.75 8.49805 15.75Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info.29877ae4431e3eb90e9256b94e8de2a4.svg";